import { render } from "./AppOther.vue?vue&type=template&id=04096570&ts=true"
import script from "./AppOther.vue?vue&type=script&lang=ts"
export * from "./AppOther.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__